import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { subscriptionTypeFormAction, typeOpenSettingsFormAction } from "../../redux/rootReducer";
import { updateSubscriptionTypeSagaAction } from "../../redux/sagaActions";
import Checkbox from "../Checkbox/Checkbox";
import { ChromePicker } from 'react-color';

const SubscriptionTypeForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const subscription_type_form = useSelector(state => state.subscription_type_form);

    // Состояние colorPicker
    const [colorPicker, setColorPicker] = useState(false);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(typeOpenSettingsFormAction('')) } />
                        <div className="form__title">{ subscription_type_form.id ? 'Редактирование типа' : 'Добавление типа' }</div>
                    </div>
                    <div className="form__field">
                        <div className="booking__color">
                            {
                                colorPicker
                                    ?
                                    <ChromePicker
                                        color={ subscription_type_form.color || '#fff' }
                                        onChangeComplete={ color => dispatch(subscriptionTypeFormAction({
                                            ...subscription_type_form,
                                            color: color.hex
                                        })) }
                                        className="booking__color-picker"
                                    />
                                    : false
                            }
                            <div className="booking__color-description">Цвет</div>
                            <div
                                className="booking__color-template"
                                style={{ backgroundColor: subscription_type_form.color || '#fff' }}
                                onClick={ () => setColorPicker(!colorPicker) }
                            />
                        </div>
                        <div className="input__caption input__caption--required">Название типа</div>
                        <input type="text" className="input" value={ subscription_type_form.name }
                            onInput={ event => dispatch(subscriptionTypeFormAction({
                                ...subscription_type_form,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Продолжительность (мин)</div>
                        <input type="number" className="input" value={ subscription_type_form.duration }
                            onInput={ event => dispatch(subscriptionTypeFormAction({
                                ...subscription_type_form,
                                duration: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <Checkbox
                            active={ subscription_type_form.hide_booking === '1' }
                            caption={ 'Скрыть в записи' }
                            handler={ () => dispatch(subscriptionTypeFormAction({
                                ...subscription_type_form,
                                hide_booking: subscription_type_form.hide_booking === '1' ? '0' : '1'
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <Checkbox
                            active={ subscription_type_form.hide_subscription === '1' }
                            caption={ 'Скрыть в абонементах' }
                            handler={ () => dispatch(subscriptionTypeFormAction({
                                ...subscription_type_form,
                                hide_subscription: subscription_type_form.hide_subscription === '1' ? '0' : '1'
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <Checkbox
                            active={ subscription_type_form.hide_one_time === '1' }
                            caption={ 'Скрыть в разовых тренировках' }
                            handler={ () => dispatch(subscriptionTypeFormAction({
                                ...subscription_type_form,
                                hide_one_time: subscription_type_form.hide_one_time === '1' ? '0' : '1'
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...subscription_type_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(subscriptionTypeFormAction({
                                                ...subscription_type_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ subscription_type_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(updateSubscriptionTypeSagaAction({
                                    id: subscription_type_form.id,
                                    name: subscription_type_form.name,
                                    duration: subscription_type_form.duration,
                                    hide_booking: subscription_type_form.hide_booking,
                                    hide_subscription: subscription_type_form.hide_subscription,
                                    hide_one_time: subscription_type_form.hide_one_time,
                                    establishments: JSON.stringify(subscription_type_form.establishments),
                                    color: subscription_type_form.color
                                }));
                            } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionTypeForm;